const sh =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const COMMENT_SHIMMER_VARIANTS = [
  { lines: ["w-[55%]", "w-[30%]"], hasReply: false },
  { lines: ["w-full", "w-[90%]", "w-[75%]"], hasReply: true },
  { lines: ["w-[70%]"], hasReply: false },
  { lines: ["w-full", "w-[85%]", "w-[65%]", "w-[40%]"], hasReply: true },
  { lines: ["w-[45%]", "w-[60%]"], hasReply: false },
];

export const ActivityContentShimmer = () => (
  <>
    {COMMENT_SHIMMER_VARIANTS.map((variant, i) => (
      <div
        key={`comment-shimmer-${i}`}
        className="border-b border-border-gray dark:border-border-gray-dk px-3 py-5 flex flex-col gap-3"
      >
        <div className="flex flex-col gap-[5px]">
          {variant.lines.map((w, j) => (
            <div key={j} className={`h-[14px] ${w} ${sh}`} />
          ))}
        </div>

        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-[5px]">
            <div className={`w-[20px] h-[20px] rounded-full shrink-0 ${sh}`} />
            <div className={`h-3 w-[72px] ${sh}`} />
          </div>
          <div className="flex items-center gap-[5px]">
            <div className={`h-3 w-[100px] ${sh}`} />
            <div className={`w-[14px] h-[14px] rounded shrink-0 ${sh}`} />
          </div>
        </div>

        {variant.hasReply && (
          <div className={`h-[30px] w-full rounded-lg ${sh}`} />
        )}
      </div>
    ))}
  </>
);
